import React from 'react';
import gridCss from '../../core/utils/Grid.js';
import { Card } from 'primereact/card';
import './CardSeplag.css';
import { useRouteMatch } from 'react-router-dom';
import { getAllRoutesByPage } from '../../core/config/Permission.js';
import styles from './CardSeplag.module.scss';

const CardSeplag = ({
    config = null,
    className = '',
    useHR = true,
    classHr = '',
    classHeader = '',
    afterComponent,
    ...props
}) => {
    const routes = getAllRoutesByPage(useRouteMatch()['path']);

    function colClasseCss() {
        let classeCss = gridCss(props.cols ? props.cols : '12');
        return classeCss;
    }
    if (config) {
        config.setIncluirPermission(routes);
    }

    function title(classHr) {
        if (props.title) {
            return (
                <>
                    <div className={`${styles.cardSeplag}`}>
                        <div
                            className={`p-col-12 ${classHeader}`}
                            style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                            }}
                        >
                            {props.handleVoltar ? (
                                <div
                                    className="p-grid "
                                    style={{ cursor: 'pointer', alignItems: 'center' }}
                                    onClick={props.handleVoltar}
                                >
                                    <div className="p-col-12 p-md-6 p-lg-4 p-xl-4  ">
                                        <div style={{ display: 'flex' }}>
                                            <i
                                                className="pi pi-angle-left"
                                                style={{
                                                    fontSize: '2rem',
                                                    margin: '1.5rem 0 1rem 0',
                                                }}
                                            />
                                            <h5 style={{ flex: 1 }}>
                                                <strong>{props.title}</strong>
                                            </h5>
                                        </div>
                                    </div>
                                    <div className="p-col-12 p-md-6">
                                        {props.legenda && props.legenda()}
                                    </div>
                                </div>
                            ) : (
                                <>
                                    <h5>
                                        <strong>{props.title} </strong>
                                        <small>{props.legenda && props.legenda()}</small>
                                    </h5>
                                    {afterComponent}
                                </>
                            )}
                        </div>
                    </div>
                    {useHR && <hr className={classHr} />}
                </>
            );
        } else {
            return <></>;
        }
    }

    return (
        <div
            className={`${colClasseCss()} ${className}`}
            style={{
                marginLeft: '0px',
                marginRight: '0px',
                paddingLeft: '0px',
                paddingRight: '0px',
            }}
        >
            <Card className={props.cardHeaderClassNames}>
                <div className="p-grid grid-lock-pagebreak justify-content-center">
                    {title(classHr)}
                    {props?.children}
                </div>
            </Card>
        </div>
    );
};

export default CardSeplag;
